module.exports = __webpack_public_path__ + "static/media/google-play-badge-en.c68e1c2f.svg";